export default {
  state: {
	  artificer:'技师'
  },
  mutations: { 
	  setArtificer(state,param){
		  state.artificer = param
	  }
  }
}